import { render, staticRenderFns } from "./SwitchItem.vue?vue&type=template&id=5de1d9d4&scoped=true"
import script from "./SwitchItem.vue?vue&type=script&lang=js"
export * from "./SwitchItem.vue?vue&type=script&lang=js"
import style0 from "./SwitchItem.vue?vue&type=style&index=0&id=5de1d9d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de1d9d4",
  null
  
)

export default component.exports